import { LegalLayout } from "@/components/LegalLayout";
import { PackageOpen } from "lucide-react";

const sections = [
  { heading: "Step 1 — Start your return", body: (
    <p>Go to <a className="text-primary underline underline-offset-2" href="/account">Account → Orders</a>, select the item and click <em>Request return</em> within 14 days of delivery.</p>
  ) },
  { heading: "Step 2 — Pack the item", body: (
    <p>Repack the product safely in its original packaging with all accessories, tags and documentation included.</p>
  ) },
  { heading: "Step 3 — Ship it back", body: (
    <p>Use the return label or address provided by the seller. Keep your proof of postage until the refund is confirmed.</p>
  ) },
  { heading: "Step 4 — Track your refund", body: (
    <p>You'll receive email updates as the seller receives and inspects your return. Approved refunds reach your original payment method within 14 days.</p>
  ) },
  { heading: "Non-returnable items", body: (
    <ul className="list-disc pl-5 space-y-1">
      <li>Perishable groceries and fresh food</li>
      <li>Personalised or custom-made products</li>
      <li>Opened hygiene, beauty or intimate goods</li>
      <li>Digital downloads and gift cards</li>
    </ul>
  ) },
  { heading: "Questions?", body: (
    <p>Visit our <a className="text-primary underline underline-offset-2" href="/return-refund-policy">Return & Refund Policy</a> or reach the <a className="text-primary underline underline-offset-2" href="/customer-service">Customer Service</a> team.</p>
  ) },
];

export default function ReturnPolicy() {
  return (
    <LegalLayout
      title="Return Policy"
      icon={PackageOpen}
      testid="return-policy-page"
      intro="A quick, step-by-step overview of how returns work on Xurray Mart for customers in the EU and Nigeria. For your full legal rights and refund timelines, see our Return & Refund Policy."
      sections={sections}
    />
  );
}
